import { Box } from '@mui/material'
import styles from './index.module.scss'

/**
 * Layout row for a user message (sender = right, receiver = left).
 * @param {{ children: React.ReactNode, dense?: boolean, align?: 'start' | 'end', messageId?: string, highlighted?: boolean }} props
 */
function UserMessageRow({
  children,
  dense = false,
  align = 'end',
  messageId,
  highlighted = false,
}) {
  const alignClass = align === 'start' ? styles.rowStart : styles.rowEnd
  const rowClass = `${dense ? `${alignClass} ${styles.rowDense}` : alignClass}${highlighted ? ` ${styles.rowFocused}` : ''}`

  return (
    <Box component="div" className={rowClass} data-message-id={messageId}>
      {children}
    </Box>
  )
}

export default UserMessageRow
